import { CodeSnippetProps } from './CodeSnippet.types';

export const requiredProps: CodeSnippetProps = {
  code: 'yarn add @wix/design-system',
};

const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as CodeSnippetProps,
  },
];

export const testkitTests = [...sharedTests];
export const ssrTests = [...sharedTests];
export const a11yTests = [...sharedTests];
